/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
const state = {
  breadcrumbs: [],
};

const mutations = {
  setBreadcrumbsMutation(state, route) {
    state.breadcrumbs.push({ ...route });
  },
  removeLastBreadcrumbMutation(state) {
    state.breadcrumbs.pop();
  },
  clearBreadcrumbsMutation(state) {
    state.breadcrumbs = [];
  },
};

const actions = {
  setBreadcrumbs({ commit }, route) {
    commit('setBreadcrumbsMutation', route);
  },
  removeLastBreadcrumb({ commit }) {
    commit('removeLastBreadcrumbMutation', state);
  },
  clearBreadcrumbs({ commit }) {
    commit('clearBreadcrumbsMutation');
  },
};

const getters = {
  getBreadcrumbs: (state) => state.breadcrumbs,
};

const routing = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default routing;
